import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';


export class BaseService {
  protected host: string = environment.apiUrl;
  protected token;

  constructor(
    public http: HttpClient,
    public basePath: string,
    public entityName: string
  ) {

  }

  options() {
    return { headers: this.headers() };
  };

  headers() {
    this.token = sessionStorage.getItem('token');
    
    let headers = {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*'
    };

    if (this.token) {
      headers["Authorization"] = this.token;
    }
    
    return headers;
  }

  getResources(params = {}) {
    return this.http.get(this.resourceUrl(null, params), this.options());
  }

  getResource(id, params = {}) {
    return this.http.get(this.resourceUrl(id, params), this.options());
  }

  createResource(data, params = {}): Observable<any> {
    return this.http.post(this.resourceUrl(null, params), JSON.stringify(data), this.options());
  }

  updateResource(data, params = {}) {
    return this.http.put(this.resourceUrl(data.id, params), JSON.stringify(data), this.options());
  }

  updateWithoutIdResource(data) {
    return this.http.put(this.resourceUrl(null), JSON.stringify(data), this.options());
  }

  deleteResource(id) {
    return this.http.delete(this.resourceUrl(id), this.options());
  }
  
  deleteResourceWithParams(id, params = {}) {
    return this.http.delete(this.resourceUrl(id, params), this.options());
  }

  resourceUrl(id = null, params = {}) {

    const endpoint = [
      this.host,
      this.basePath,
      this.urlParameters(params),
      this.entityName,
      id
    ].filter(element => element != false).join('/').replace(/\/$/, '')

    return endpoint + this.queryString(params)
  }

  protected urlParameters(params) {
    var urlParameters = []

    for(var placeholder in params)
      if (/.*_id$/.test(placeholder))
        urlParameters.push(`${placeholder}/${params[placeholder]}`)

    return urlParameters.join('/')
  }

  protected queryString(params) {
    if(params.query){
      return `?${params.query}`
    }else if(params.router){
      return `/${params.router}`    
    }else {
      return ''
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/services/base.service.ts